import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import apiClient from './api/apiClient';
import CheckDetailsComponent from './CheckDetailsComponent'; // adjust path as needed


const AddressCheckOne = () => {
  const location = useLocation();
  const { caseId, checkId, checkType } = location.state || {};
  const [checkDetails, setCheckDetails] = useState(null);

  useEffect(() => {
    if (caseId && checkId && checkType) {
      fetchCheckDetails();
    }
  }, [caseId, checkId, checkType]);

  const fetchCheckDetails = async () => {
    try {
      const response = await apiClient.get(`/addresscheckones/${caseId}/${checkType}/${checkId}`);
      setCheckDetails(response.data);
    } catch (error) {
      console.log("Error ", error);
    }
  };

  const handleLhsChange = (field, value) => {
    setCheckDetails(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleRhsChange = (field, value) => {
    setCheckDetails(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div>
      {checkDetails ? (
        <CheckDetailsComponent
          lhsDetails={checkDetails}
          rhsDetails={checkDetails}
          onChangeLhs={handleLhsChange}
          onChangeRhs={handleRhsChange}
        />
      ) : (
        <p>Loading check details...</p>
      )}
    </div>
  );
};

export default AddressCheckOne;
